"use strict";import"./sp-slider-handle.js";import{Slider as e}from"./src/Slider.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-slider",e);
//# sourceMappingURL=sp-slider.js.map
